/**
 * M901 — Provider-aware UI copy + branding flags.
 *
 * Centralised so we never sprinkle `if (provider === "netopia") …` across
 * Checkout, Footer, Success, etc. Every component that needs provider-
 * specific copy reads the active config through `getPaymentBranding(id)`.
 *
 * Faza 2 deliberately uses NEUTRAL language ("Plată securizată prin
 * EuPlătesc" with a generic CreditCard icon — no third-party logo, no
 * copyright risk). The Netopia entry keeps the trust strip + branded copy
 * because Netopia is a long-standing brand for our audience and the
 * official assets are already shipped in /public/assets.
 *
 * If a runtime value ever ends up unknown, we fall back to `_NEUTRAL` —
 * never crash, never leak "Netopia" copy on an EuPlătesc transaction.
 */

const _NEUTRAL = {
  id: "neutral",
  displayName: "procesator de plăți",
  securePaymentText: "Plată securizată online",
  redirectingText: "Te redirectăm către pagina de plată…",
  awaitingConfirmationText: "Așteptăm confirmarea plății.",
  inlineNoticeText: "Vei fi redirecționat către pagina securizată de plată pentru introducerea datelor cardului.",
  buttonHelperText: "Plată securizată cu cardul prin procesatorul nostru de plăți",
  // Visual hooks — Netopia-only assets stay opt-in.
  showNetopiaTrustStrip: false,
  showNetopiaBanner: false,
};

export const PAYMENT_BRANDING = {
  netopia: {
    id: "netopia",
    displayName: "Netopia Payments",
    securePaymentText: "Plată securizată prin Netopia Payments",
    redirectingText: "Te redirectăm către Netopia Payments…",
    awaitingConfirmationText:
      "Așteptăm confirmarea de la Netopia Payments. Vei primi un email imediat ce plata este finalizată.",
    inlineNoticeText:
      "Vei fi redirecționat(ă) către pagina securizată Netopia Payments pentru introducerea datelor cardului.",
    buttonHelperText: "Plată securizată cu cardul prin Netopia Payments",
    showNetopiaTrustStrip: true,
    showNetopiaBanner: true,
  },
  euplatesc: {
    id: "euplatesc",
    displayName: "EuPlătesc",
    securePaymentText: "Plată securizată prin EuPlătesc",
    redirectingText: "Te redirectăm către EuPlătesc…",
    awaitingConfirmationText:
      "Așteptăm confirmarea de la EuPlătesc. Vei primi un email imediat ce plata este finalizată.",
    inlineNoticeText:
      "Vei fi redirecționat(ă) către pagina securizată EuPlătesc pentru introducerea datelor cardului.",
    buttonHelperText: "Plată securizată cu cardul prin EuPlătesc",
    showNetopiaTrustStrip: false,
    showNetopiaBanner: false,
  },
};

/**
 * Resolve the branding entry for a provider id. Unknown / empty / null →
 * neutral copy. Never returns undefined — callers may safely deref `.x`.
 */
export function getPaymentBranding(providerId) {
  if (!providerId) return _NEUTRAL;
  return PAYMENT_BRANDING[providerId] || _NEUTRAL;
}
